/**
 * Processor freshness — rolling 365 days from the later of admin
 * approval (`confirmedAt`) or a hunt-flow check-in.
 */

const DAY_MS = 24 * 60 * 60 * 1000;
export const PROCESSOR_CONFIRMED_FOR_DAYS = 365;
const YEAR_MS = PROCESSOR_CONFIRMED_FOR_DAYS * DAY_MS;

const BADGES = {
  today: { label: 'CONFIRMED TODAY', tone: 'loden' },
  season: { label: 'VERIFIED', tone: 'loden' },
  stale: { label: 'STALE', tone: 'mustard' },
  none: { label: 'UNCONFIRMED', tone: 'none' },
};

function toDate(value) {
  if (!value && value !== 0) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function readEventTime(event) {
  if (!event || typeof event !== 'object') return null;
  return toDate(event.at ?? event.created_at ?? event.created ?? event.when);
}

function collectActivityTimes({ confirmations = [], checkIns = [], confirmedAt } = {}) {
  const times = [];
  const confirmed = toDate(confirmedAt);
  if (confirmed) times.push(confirmed);
  checkIns.forEach((event) => {
    const at = readEventTime(event);
    if (at) times.push(at);
  });
  confirmations.forEach((event) => {
    if (String(event?.state || '').toLowerCase() === 'full') return;
    const at = readEventTime(event);
    if (at) times.push(at);
  });
  return times;
}

export function deriveFreshness({
  confirmations = [],
  checkIns = [],
  confirmedAt,
  now = new Date(),
} = {}) {
  const current = toDate(now) || new Date();
  const times = collectActivityTimes({ confirmations, checkIns, confirmedAt });
  if (!times.length) return 'none';

  const latest = times.reduce((max, date) => (date > max ? date : max));
  const age = current - latest;
  if (age <= DAY_MS && latest <= current) return 'today';
  if (age <= YEAR_MS) return 'season';
  return 'stale';
}

export function freshnessBadge(value) {
  return BADGES[value] || BADGES.none;
}

export function isFreshThisSeason(value) {
  return value === 'today' || value === 'season';
}
